//@ts-check
//@ts-ignore
import PassChange from './pass-change.riot';
import { changeRequest, changeSuccess, changeFailure, changeCheckRequest, changeCheckSuccess, changeCheckFailure } from './password.action';
import { ajaxPost } from '../ajax';
import { router } from '@riotjs/route';
import { connect } from '@/common/lib/riot-redux';

const mapDispatchToProps = (dispatch, props) => ({
  async passwordChangeCheck() {
    if (props.passKey == null) {
      return;
    }
    
    dispatch(changeCheckRequest());
    try {
      await ajaxPost('/password', {
        method: 'changeUrl',
        key: props.passKey
      });
      dispatch(changeCheckSuccess());
    } catch (e) {
      dispatch(changeCheckFailure(e));
      router.push('result');
    }
  },

  async changeUrl(data) {
    dispatch(changeRequest());
    try {
      await ajaxPost('/password', {
        method: 'changeUrl',
        key: props.passKey,
        password: data.password
      });
      dispatch(changeSuccess());
      router.push('login');
    } catch (e) {
      dispatch(changeFailure(e));
      router.push('result');
    } 
  }
});

export default connect(PassChange, null, mapDispatchToProps);